<div class="flex justify-end">
  <div class="bg-background-green-light border-1 border-border-secondary-dark p-md rounded-md max-w-[485px] whitespace-pre-line text-content-text-body-primary">
    {{ content }}
  </div>
</div>
